/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGroupsGetQueryResponse, StationsStationsGroupsGetPathParams } from "../models/StationsStationsGroupsGet";

export function getStationsStationsGroupsGetUrl(stationGroupId: StationsStationsGroupsGetPathParams["stationGroupId"]) {
  const res = { method: 'GET', url: `/station-groups/v1/${stationGroupId}` as const }
  return res
}

/**
 * @description Returns a stations group by id or slug, including its stations.
 * @summary Get stations group
 * {@link /station-groups/v1/:stationGroupId}
 */
export async function stationsStationsGroupsGet(stationGroupId: StationsStationsGroupsGetPathParams["stationGroupId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StationsStationsGroupsGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationsStationsGroupsGetUrl(stationGroupId).url.toString(), ... requestConfig })
  return res.data
}